// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2pRNi","alert":"SettungsInbox_alert__364X7"};